<template>

    <div id="app-wrapper">
        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
        <transition name="dim">
            <div v-if="modal" class="modal-backdrop" @click="hideModal"></div>
        </transition>
    </div>

</template>

<style scoped lang="scss">

    #app-wrapper {
        height: 100%;
        min-height: 100%;
    }

</style>

<script>

export default {

    watch: {

        '$i18n.locale': {
            handler(lang) {
                document.documentElement.lang = lang || 'en';
            },
            immediate: true,
        },

        modal(val) {
            let wrapper = document.getElementById('app-wrapper');
            if (val) {
                document.body.classList.add('modal-open');
                if (wrapper.scrollHeight > wrapper.clientHeight) {
                    wrapper.style.padding = '0 15px 0 0';
                }
            } else {
                document.body.classList.remove('modal-open');
                wrapper.style.padding = '0';
            }
        },

    },

    methods: {

        hideModal() {
            this.$store.commit('setModal', null);
        },

    },

}

</script>